import React from 'react'
import "./Looder.css"

const Looder = () => {
  return (
    <>
      <span class="loader"></span>

    </>
  )
}

export default Looder;
